export const themeOptions = [
  { value: 'Adventure', label: 'Adventure' },
  { value: 'Mystery', label: 'Mystery' },
  { value: 'Fantasy', label: 'Fantasy' },
  { value: 'Friendship', label: 'Friendship' },
  { value: 'Learning', label: 'Learning' },
  { value: 'Courage', label: 'Courage' },
  { value: 'Kindness', label: 'Kindness' },
  { value: 'Teamwork', label: 'Teamwork' },
  { value: 'Perseverance', label: 'Perseverance' },
  { value: 'Creativity', label: 'Creativity' },
  { value: 'Responsibility', label: 'Responsibility' },
  { value: 'Honesty', label: 'Honesty' },
  { value: 'Respect', label: 'Respect' },
  { value: 'Family', label: 'Family' },
  { value: 'Nature', label: 'Nature' },
];

export const settingOptions = [
  { value: 'Enchanted Forest', label: 'Enchanted Forest' },
  { value: 'Underwater Kingdom', label: 'Underwater Kingdom' },
  { value: 'Space Station', label: 'Space Station' },
  { value: 'Medieval Castle', label: 'Medieval Castle' },
  { value: 'Futuristic City', label: 'Futuristic City' },
  { value: 'Magical School', label: 'Magical School' },
  { value: 'Pirate Ship', label: 'Pirate Ship' },
  { value: 'Dinosaur Island', label: 'Dinosaur Island' },
  { value: 'Fairy Tale Village', label: 'Fairy Tale Village' },
  { value: 'Haunted House', label: 'Haunted House' },
  { value: 'Circus', label: 'Circus' },
  { value: 'Ancient Egypt', label: 'Ancient Egypt' },
  { value: 'Arctic Tundra', label: 'Arctic Tundra' },
  { value: 'Tropical Jungle', label: 'Tropical Jungle' },
  { value: 'Cloud City', label: 'Cloud City' },
];

export const styleOptions = [
  { value: 'Normal', label: 'Normal' },
  { value: 'Rhyming', label: 'Rhyming' },
  { value: 'Interactive', label: 'Interactive' },
  { value: 'Humorous', label: 'Humorous' },
  { value: 'Mystery', label: 'Mystery' },
  { value: 'Fairy Tale', label: 'Fairy Tale' },
  { value: 'Adventure', label: 'Adventure' },
  { value: 'Educational', label: 'Educational' },
  { value: 'Fable', label: 'Fable' },
  { value: 'Sci-Fi', label: 'Sci-Fi' },
];
